<template>
  <!-- prettier-ignore -->
  <div
    ref="el"
    class="ab-config"
    data-is-onboarding-route-based="true"
  />
</template>

<script>
/**
 * --> data-is-onboarding-route-based <--
 * NOTE: DEACTIVATED 31.10.2022 - CAN BE REMOVED
 * controls, how the onboarding is triggered on the basket screen
 * true = onboarding-route is active and used
 * false = onboarding is shown in modal
 *
 */
</script>

<script setup>
import { onMounted, ref } from 'vue'

import { useABConfig } from '@/hooks'

// Hooks
const { abConfig } = useABConfig()

// Data
const el = ref()

// Lifecycle
onMounted(() => {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') {
        updateValues()
      }
    })
  })
  observer.observe(el.value, { attributes: true })

  updateValues()
})

// Methods
function updateValues() {
  for (const key in el.value.dataset) {
    if (el.value.dataset[key]) {
      let configValue = el.value.dataset[key]
      switch (el.value.dataset[key]) {
        case 'true':
          configValue = true
          break

        case 'false':
          configValue = false
          break
      }

      abConfig.value[key] = configValue
    }
  }
}
</script>

<style scoped>
.ab-config {
  display: contents;
}
</style>
